import { copilotTools as l, copilotContext as s } from "./global-state.js";
import { prepareInstructionsForTransport as i, prepareToolsForTransport as u, prepareContextForTransport as o } from "./session.js";
function c(r, n, t = {}) {
  t = {
    instructions: t.instructions ?? [],
    context: t.context ?? [],
    includeGlobalContext: !0,
    includeGlobalTools: !1,
    ...t
  };
  const e = window.__hydra_copilot__?.generate;
  if (e == null)
    throw new Error("Copilot generate not configured. Please set the Copilot configuration first.");
  return e({
    message: r,
    schema: n,
    instructions: [...i(t.instructions)],
    tools: t.includeGlobalTools ? u(l.get()) : [],
    context: [
      ...t.includeGlobalContext ? o(s.get()) : [],
      ...o(t.context)
    ],
    ...t.includeUserContext === !0 && { include_user_context: !0 }
  });
}
export {
  c as generate
};
